import { Button } from "antd";
import CheckPermission from "../../../hoc/CheckPermission";

interface PaymentCellProps {
  customer: any;
  isAuthenticated: boolean;
  isAdmin: boolean;
  paymentLoading: boolean;
  selectedSoNo: string | undefined;
  onShowPayment: (order: any) => void;
}

export function PaymentCell({
  customer,
  isAuthenticated,
  isAdmin,
  paymentLoading,
  selectedSoNo,
  onShowPayment,
}: PaymentCellProps) {
  if (!isAuthenticated) return null;
  if (isAdmin) {
    return <span>{customer.paymentStatus === 1 ? "Paid" : "Unpaid"}</span>;
  }
  return (
    <CheckPermission has="OrderPay">
      <div className="action__btn__wrapper">
        {customer.allowPayButton ? (
          <Button
            disabled={paymentLoading}
            loading={paymentLoading && selectedSoNo === customer.soNo}
            type="primary"
            onClick={() => onShowPayment(customer)}
          >
            pay
          </Button>
        ) : (
          ""
        )}
      </div>
    </CheckPermission>
  );
}
